import { useNavigate, useParams } from "react-router-dom";
import { PolicyCancellationForm } from "../../Cancellation/PolicyCancellationForm";
import { useBusinessPremium } from "../../../../../../hooks/useCustomerPremium";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { useCustomerPolicyDetails } from "../../../../../../hooks";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const BusinessCancellation: React.FC<{ isDuplicate?: boolean }> = (
  props
) => {
  const { customerId, customerPolicyId, serialNumber } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    serialNumber?: number;
  };

  const { isDuplicate } = props;

  const premium = useBusinessPremium(customerPolicyId);
  const agencyBill = premium.data.agency_bill_or_direct_bill;
  const { details: policyAdmin, insurer, branch } = useCustomerPolicyDetails(customerPolicyId);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(
      `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=4`
    );
  };
  return (
     <PageContainer
        title={serialNumber ? "Edit business cancellation" : "Create business cancellation"}
        description="This is the consent form page"
      >
      {customerPolicyId && customerId && (
        <PolicyCancellationForm
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          incrementalNumber={serialNumber}
          isDuplicate={isDuplicate}
          handleNavigate={handleNavigate}
          agencyBill={agencyBill}
          policy="business"
          lineOfBusiness={policyAdmin.data.line_of_business}
          subType={policyAdmin.data.policy_sub_type}
          customerCode={policyAdmin.data.customer_code}
          customerName={policyAdmin.data.customer_name}
          policyNumber={policyAdmin.data.policy_number || policyAdmin.data.binder_number}
          branch={branch.branch_code}
          broker_code={policyAdmin.data.broker_code}
          producer_one_code={policyAdmin.data.producer_one_code}
          producer_one_id={policyAdmin.data.producer_one}
          csr={policyAdmin.data.csr_code}
          insurer={`${insurer.name}(${insurer.insurer_code})`}
          securityType={`${MODULE_IDS.BUSINESS_POLICY}`}
        />
      )}
    </PageContainer>
  );
};
